import { render, staticRenderFns } from "./TakipSorgulaIslemDetayView.vue?vue&type=template&id=06bdd0da&scoped=true"
import script from "./TakipSorgulaIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TakipSorgulaIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bdd0da",
  null
  
)

export default component.exports